import { render, staticRenderFns } from "./AdvertiseType.vue?vue&type=template&id=6b54d6a6&scoped=true&lang=pug"
import script from "./AdvertiseType.vue?vue&type=script&lang=js"
export * from "./AdvertiseType.vue?vue&type=script&lang=js"
import style0 from "./AdvertiseType.vue?vue&type=style&index=0&id=6b54d6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b54d6a6",
  null
  
)

export default component.exports